module.exports = __webpack_public_path__ + "img/house-blank.90c3ab14.svg";